import { makeStyles } from '@material-ui/core';
import theme from 'src/config/theme';

export const useStyles = makeStyles({
  tooltip: {
    backgroundColor: theme.palette.white,
    padding: 16,
    color: '#000000',
    borderRadius: 8,
    boxShadow: '0px 1px 8px 0px #000000',
    lineHeight: 16,
  },
  tooltipArrow: {
    backgroundColor: 'transparent',
    fontSize: '1.5rem',
    color: '#FFFFFF',
    boxShadow: '0px 0px 0px 0px #000000',
    lineHeight: 16,
  },
});
